var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNumber3Xs = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8ZM16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM7.80078 12.1094C5.9375 12.1094 4.67969 11.1055 4.64844 9.64844H6.59766C6.625 10.1836 7.14062 10.5391 7.80469 10.5391C8.50391 10.5391 8.97266 10.1406 8.97266 9.5625C8.97266 8.97266 8.47656 8.57031 7.64844 8.57031H6.70703V7.26562L8.41016 5.60938V5.55859H5.05078V4H10.7383V5.39062L8.58203 7.42188V7.48438C10.3711 7.68359 11 8.73828 11 9.71094C11 11.1523 9.61719 12.1094 7.80078 12.1094Z",
  fill: "currentColor"
})));
export { SvgNumber3Xs as ReactComponent };